import treeStore from "./treeStore";
import searchStore from "./searchStore";
import dragStore from "./dragStore";
import communicatorStore from "./communicatorStore";

class rootStore {
  treeStore=null;
  searchStore=null;
  dragStore=null;
  communicatorStore=null;
  root_element=null;
  name_field="name";
  routes= {
    tree:"",
    data:"",
    move:""
  }

  constructor(initial) {
    const defaultRoutes={
      tree:`/sysapi/dynamic/${initial.category}/sections/tree`,
      data:`/sysapi/dynamic/${initial.category}/sections`,
      move:`/sysapi/dynamic/${initial.category}/sections/move`
    };

    if(initial.routes) {
      for(let i in this.routes) {
        if(initial.routes[i]) {
          this.routes[i]=initial.routes[i];
        } else {
          this.routes[i]=defaultRoutes[i];
        }
      }
    } else {
      this.routes=defaultRoutes;
    }
    if(initial.name_field) {
      this.name_field=initial.name_field;
    }

    this.treeStore=new treeStore(this);
    this.searchStore=new searchStore(this);
    this.dragStore=new dragStore(this);
    this.communicatorStore=new communicatorStore(this);

    if(initial.onMessage) {
      this.communicatorStore.onMessage=initial.onMessage;
    }

    window.communicatorStore=this.communicatorStore;

    if(initial.category) {
      this.treeStore.setCategory(initial.category);
      this.searchStore.category=initial.category;
    }
    if(initial.title) {
      this.treeStore.title=initial.title;
    }

  }

  getStores() {
    return {
      treeStore: this.treeStore,
      searchStore: this.searchStore,
      dragStore: this.dragStore,
      communicatorStore: this.communicatorStore,
    }
  }
}

export default rootStore;
